import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-comp',
  templateUrl: './common-comp.component.html',
  styleUrls: ['./common-comp.component.css']
})
export class CommonCompComponent implements OnInit {

  // List all DocumentAuto
  documentAuto = [
    { id: '1', name: 'Mẫu tài liệu A' },
    { id: '2', name: 'Mẫu tài liệu B' },
    { id: '3', name: 'Mẫu tài liệu C' },
  ];

  // List all createrAuto
  createrAuto = [
    { id: '1', name: 'Lê Văn B' },
    { id: '2', name: 'Lê Văn C' },
    { id: '3', name: 'Lê Văn A' },
  ];

  // Selected model value for autocomplete
  selected: { id: string, name: '' };

  // Selected model value for autocomplete
  selected1: { id: string, name: '' };

  document = {
    name: null,
  };

  creater = {
    name: null,
  };

  constructor() { }

  ngOnInit() {
  }

  /**
   * Detect value changing in autocomplete input
   */
  onChangeAutoCompleted() {
    if (this.selected === null || this.selected === undefined) {
      this.document.name = '';
    } else {
      this.document.name = this.selected.name;
    }
  }

  /**
   * Detect value changing in autocomplete input
   */
  onChangeAutoCompletedForCreater() {
    if (this.selected1 === null || this.selected1 === undefined) {
      this.creater.name = '';
    } else {
      this.creater.name = this.selected1.name;
    }
  }
}
